import { t, Trans } from '@lingui/macro'
import { Box, FormLabel, MenuItem } from '@mui/material'
import { useFormikContext } from 'formik'
import { FC } from 'react'
import { TextFieldWithFormik } from '../common-components/with-formik/TextFieldWithFormik'
import { ResourcesDetailsButton, ResourcesDetailsLightButton } from '../resources/ResourcesDetailsCard/Button'
import { FirstLoginFlowFormikProps } from './index'

import { i18n } from '@lingui/core'
import { parseSFApiValueToTranslationId } from 'translation/translationUtils'
import { GoalOption } from './useGoalOption'

interface GoalSelectionProps {
  goalOptions: GoalOption[]
}

export const GoalSelection: FC<GoalSelectionProps> = ({ goalOptions }) => {
  const {
    values, handleChange, handleBlur, setFieldValue, validateForm, setFieldTouched
  } = useFormikContext<FirstLoginFlowFormikProps>()

  const onClickContinue = async () => {
    const errors = await validateForm()
    if (errors.goal) {
      setFieldTouched('goal', true)
    } else {
      setFieldValue('goalCompleted', true)
    }
  }

  return (
    <>
      <FormLabel>
        <Trans>FIRST_LOGIN_FLOW_WHAT_ARE_YOU_LOOKING_FOR_LABEL</Trans>
      </FormLabel>
      <TextFieldWithFormik
        select
        name='goal'
        value={values.goal}
        onChange={handleChange}
        onBlur={handleBlur}
        required
      >
        {goalOptions.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {i18n._(t`${parseSFApiValueToTranslationId(option.label)}`)}
          </MenuItem>
        ))}
      </TextFieldWithFormik>
      <Box sx={{ display: 'flex', gap: '16px', mt: '24px' }}>
        <ResourcesDetailsButton
          text={<Trans>FIRST_LOGIN_FLOW_CONTINUE_BUTTON</Trans>}
          onClick={onClickContinue}
        />
        {values.goal && <ResourcesDetailsLightButton
          text={<Trans>FIRST_LOGIN_FLOW_BACK_BUTTON</Trans>}
          onClick={() => {
            setFieldValue('goal', '')
            setFieldValue('goalCompleted', false)
          }}
                        />}
      </Box>
    </>
  )
}
